export default {
  'calander.guide': 'カレンダーガイド',
  'calander.redtheme': '赤色',
  'calander.graytheme': '灰色',
  'calander.greentheme': '緑色',
  'calander.bluetheme': '青色',
  'calander.guidetitle': 'カレンダーの下の行事の色は以下の通りです。',
  'calander.redthemeguide': 'この色は選択された国の公式の祝日を示します。',
  'calander.graythemeguide': 'この色は選択された国の宗教的な行事を示します。',
  'calander.greenthemeguide': 'この色は選択された国の先住民の行事を示します。',
  'calander.bluethemeguide':
    'この色は選択された国の伝統的な地元の行事を示します。',
  'calander.selectCountry': '「イベントを表示する国名」',
  'calander.changeDate': '変更日',
  'calander.changeType': 'タイプを変更',
  'calander.shamsi': 'Shamsi',
  'calander.miladi': 'Miladi',
  'calander.hijri': 'Hijri',
  'otheroption.otheroptions': 'その他のオプション',
  'calendar.calculateDate': '日付の計算',
  'otheroption.departuredate': '出発日',
  'otheroption.returndate': '帰還日',
  'otheroption.dayscount': '日数のカウント',
  'otheroption.calculate': '計算する',
  'otheroption.timeinterval': '時間間隔（年齢',
  'otheroption.alertinsertresult.ja': '入力された日付が無効です。',
  'otheroption.untiltodayfuture': '今日からの残り時間。',
  'otheroption.untiltodaypast': '今日までの経過時間。',
  'otheroption.otheroptionsguide1':
    'カレンダーの上部で国を選択することで、その国に特有のイベントがカレンダーに設定されます。',
  'otheroption.otheroptionsguide2':
    '日付の上にマウスカーソルを置くと、その日のイベントがカレンダーの下部に表示されます。',
  'otheroption.otheroptionsguide3':
    '2つの日付をクリックすると、それらの間の時間間隔が表示されます。',
  'otheroption.otheroptionsguide4':
    'カレンダーのすべてのイベントは、カレンダーのイベントセクションにリスト形式で提供されます。',
};
